// Splits PickSelect options into consecutive runs sharing one `group` heading
// (ungrouped options form runs with group undefined). Shared with the jest mock.
export function groupRuns(options) {
  const runs = [];
  options.forEach((o) => {
    const last = runs[runs.length - 1];
    if (last && last.group === o.group) last.items.push(o);
    else runs.push({ group: o.group, items: [o] });
  });
  return runs;
}
